import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, DownloadIcon, FlameIcon, GiftIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productImageAlt, productLabel, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: DownloadIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-zinc-950" data-id="element-86" data-mp="s9ghy2ytqm9r">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-87" data-mp="nb6n5th0hnoo">
        <span className="flex-1 bg-teal-700" data-id="element-88" data-mp="3d1ihv20l0yjq" />
        <span className="w-24 bg-orange-500 shadow-[0_0_10px_rgba(249,115,22,0.6)]" data-id="element-89" data-mp="3d2bj5ngruvuh" />
        <span className="flex-1 bg-teal-700" data-id="element-90" data-mp="381e1dbzoc3ti" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-91" data-mp="3j8iwsycd6eu6">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-orange-400/50 bg-zinc-900 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-white" data-id="element-92" data-mp="3j6od1nctwsro">
          <FlameIcon className="h-4 w-4 shrink-0 text-orange-400 drop-shadow-[0_0_6px_rgba(251,146,60,0.55)]" aria-hidden="true" data-id="element-93" data-mp="30ggezjnzksic" /> {productLabel}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-94" data-mp="2qkmrx6cn5gmb">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full [filter:drop-shadow(0_0_28px_rgba(251,146,60,0.35))_drop-shadow(0_0_70px_rgba(217,119,6,0.3))]" data-id="element-95" data-mp="2lkqxnytqx3jy" />
        </motion.div>

        <div className="mt-9" data-id="element-96" data-mp="nbbe31x26h6v">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-97" data-mp="naa12rwhfkmi">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-98" data-mp="dd5c6kb95b20">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-teal-700/60 bg-zinc-900 px-3 py-2" data-id="element-99" data-mp="1b0duy7jvc60b">
              <Icon className="h-3.5 w-3.5 text-teal-400 drop-shadow-[0_0_6px_rgba(45,212,191,0.55)]" aria-hidden="true" data-id="element-100" data-mp="112pwp7n20gde" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}